import React from 'react';
import AUX from '../../../hoc/Aux_';
import ReactApexChart from 'react-apexcharts';

const TopMembersChart = ({ members }) => {
  // Process member data for categories (names of members)
  const categories = members.map(
    (member) => `${member.firstName} ${member.lastName}`
  );

  // Convert totalTime (seconds) to minutes and prepare series data
  const seriesData = members?.map((member) => {
    const totalTimeInSeconds = member?.totalTime; // Assuming `totalTime` is in seconds
    return Math.floor(totalTimeInSeconds / 60); // Convert to minutes
  });

  const options = {
    chart: {
      height: 350,
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false, // Hide the toolbar
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      categories, // Use dynamic categories from members
    },
    yaxis: {
      min: 0, // Set the minimum value for Y-axis
      max: 540, // Set the maximum value of Y-axis (540 minutes = 9 hours)
      tickAmount: 9, // Set 9 ticks to divide the Y-axis into 9 intervals (1h, 2h, ..., 9h)
      labels: {
        formatter: function (val) {
          const hours = Math.floor(val / 60);
          return `${hours}h`; // Display the value in hours (e.g., 1h, 2h, ...)
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          const hours = Math.floor(val / 60);
          const minutes = val % 60;
          return `${hours}h ${minutes}m`; // Display in "hh mm" format in the tooltip
        },
      },
    },
    fill: {
      opacity: 1,
    },
    colors: ['#47b8c6', '#f2f2f2'],
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 40,
    },
  };

  const series = [
    {
      name: 'Total Time (minutes)',
      data: seriesData, // Use numerical series data
    },
  ];

  return (
    <AUX>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height="400"
      />
    </AUX>
  );
};

export default TopMembersChart;
